import type { VoidFunctionComponent } from 'react';

import { isProjects, isReleaseGroups, isSharedProjects } from '../../../../../shared/projectsV2';
import type { Project, ProjectCategory, ReleaseGroup } from '../../../../../shared/projectsV2';

import ProjectItem from './ProjectItem';
import ReleaseGroupItem from './ReleaseGroupItem';

type Props = {
  category: ProjectCategory;
  projects: Project[] | ReleaseGroup[];
};

const ProjectsTableBody: VoidFunctionComponent<Props> = ({ category, projects }) => {
  return (
    <div className="projects-table__body">
      {
        (isProjects(category) || isSharedProjects(category))
        && projects.map((project) => <ProjectItem project={project as Project} key={(project as Project).id} />)
      }
      {
        isReleaseGroups(category)
        && projects.map((releaseGroup) => (
          <ReleaseGroupItem releaseGroup={releaseGroup as ReleaseGroup} key={(releaseGroup as ReleaseGroup).id} />
        ))
      }
    </div>
  );
};

export default ProjectsTableBody;
